module.exports = __webpack_public_path__ + "assets/5efe42fa763e6b1c1607106f12a97af6.svg";